<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <button mat-raised-button routerLink="/sites" class="m-1 mr-2">
    <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
  </button>

  <button mat-raised-button *ngIf="site.parent_site_id" [routerLink]="'/sites/'+site.parent_site_id+'/children'" class="m-1 mr-2">
    <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}
  </button>
</nav>

<div class="container-fluid p-0">

  <div class="card rounded-0">
    <div class="card-body p-0">

      @if(site.id && site.sssp && site.sssp.id) {
        @if(canEditSafetyPlan) {
          <app-sssp-tabs [sssp_hash]="site.sssp.sssp_hash"></app-sssp-tabs>
        } @else {
          <div class="alert alert-warning m-3" role="alert">
            <mat-icon class="align-middle">info</mat-icon>
            You do not have permission to edit the {{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}.
          </div>
        }
      } @else {
        <div class="p-3" *ngIf="canCreateSafetyPlan">
          <button 
            type="button" 
            mat-raised-button 
            color="primary"
            (click)="onCreateSSSP()" 
            matTooltip="Create a new master {{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}." 
            matTooltipPosition="above">
            Create Main {{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}
          </button>
        </div>

        <div class="p-3" *ngIf="!canCreateSafetyPlan">
          <div class="alert alert-warning m-3" role="alert">
            <mat-icon class="align-middle">info</mat-icon>
            You do not have permission to create a {{ utils.getLangTerm('safety-plans.singular', 'Safety Plan') }}.
          </div>
        </div>
      }
    </div>
  </div>
</div>
